/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import '@suntex.classic/createjs';
import '@suntex.classic/utils/global';
import { synthesizeSpeech } from '@suntex.fim/a11y';

import './prototype/string';

function initGlobalLibraries() {
  const Suntex = window.Suntex || ({} as typeof window.Suntex);
  window.Suntex = Suntex;
  Suntex.FirstInMath =
    Suntex.FirstInMath || ({} as typeof window.Suntex.FirstInMath);
  Suntex.FirstInMath.Common =
    Suntex.FirstInMath.Common ||
    ({} as typeof window.Suntex.FirstInMath.Common);
  Suntex.FirstInMath.Common.synthesizeSpeech = synthesizeSpeech;
}

declare global {
  interface Window {
    /**
     * This is a global library that is used for backwards compatibility with legacy module code.
     * @deprecated
     */
    Suntex: {
      FirstInMath: {
        Common: {
          synthesizeSpeech: typeof synthesizeSpeech;
        };
      };
    };
  }
}

initGlobalLibraries();

export {};
